import React, { useState, useEffect , useRef} from "react";
import { FullScreenWidget } from "./FullScreenDesktopWidget";
import { MinimizedAndMobileWidget } from "./MinimizedAndMobileWidget";
import { useChat } from "../contexts/ChatProvider";

export const Widget = ({ remoteName = "", onSend }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { isMobile, setMessages, setStartIndex, startIndex } = useChat();

  useEffect(() => {
    if (isMobile) {
      setIsFullScreen(false);
    }
  }, [isMobile, startIndex]);

  const toggleFullScreen = () => {
    setIsFullScreen(prev => !prev);
  };

  return (
    <>
      {(isMobile || !isFullScreen) ? (
        <MinimizedAndMobileWidget
          remoteName={remoteName}
          onSend={onSend}
          onScreenExpand={toggleFullScreen}
        />
      ) : (
        <FullScreenWidget
          remoteName={remoteName}
          onSend={onSend}
          onScreenMinimize={toggleFullScreen}
        />)}
    </>
  );
};